export const minWithUndefined = (
  ...numbers: Array<number | undefined>
): number | undefined => {
  return numbers.reduce(
    (acc: number | undefined, curr): number | undefined =>
      curr === undefined ? acc : acc === undefined ? curr : Math.min(acc, curr),
    undefined,
  )
}

export const truncateNumber = (num: number, max: number): string =>
  num > max ? `${max}+` : num.toString()
